import { styled, Typography } from '@mui/material';
import { Flex, FlexProps } from '../layout';

type AppLogoProps = FlexProps & {
  version: string;
};

export const AppVersionLabel = ({ version, ...props }: AppLogoProps) => {
  return (
    <AppVersionStyledFlex alignCenter justifyCenter {...props}>
      <Typography
        variant="caption"
        sx={(theme) => ({
          color: theme.palette.text.disabled,
          fontSize: '12px',
        })}
      >
        v{version}
      </Typography>
    </AppVersionStyledFlex>
  );
};

const AppVersionStyledFlex = styled(Flex)`
  margin-top: 0px;
  margin-bottom: 0px;
`;
